import { FC } from 'react';
import { Card, Table, Empty, Typography } from 'antd';
import { AdditionalGuardianAdmin } from '../../../../../models/admin/student-admin.model';

const { Text } = Typography;

interface AdditionalGuardiansTabProps {
  guardians: AdditionalGuardianAdmin[];
}

const AdditionalGuardiansTab: FC<AdditionalGuardiansTabProps> = ({
  guardians,
}) => {
  const formatAddress = (guardian: AdditionalGuardianAdmin) => {
    const parts = [
      guardian.address,
      guardian.city,
      guardian.state,
      guardian.zip,
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(', ') : '-';
  };

  const columns = [
    {
      title: 'Name',
      key: 'name',
      render: (_: any, record: AdditionalGuardianAdmin) =>
        `${record.firstName} ${record.lastName}`,
    },
    {
      title: 'Relation',
      dataIndex: 'relation',
      key: 'relation',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (phone: string, record: AdditionalGuardianAdmin) => (
        <div>
          <div>{phone || '-'}</div>
          {record.altPhone && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              Alt: {record.altPhone}
            </Text>
          )}
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (email: string | null) => email || '-',
    },
    {
      title: 'Address',
      key: 'address',
      render: (_: any, record: AdditionalGuardianAdmin) =>
        formatAddress(record),
    },
  ];

  return (
    <Card title="Additional Guardians">
      {guardians.length > 0 ? (
        <Table
          dataSource={guardians}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="middle"
        />
      ) : (
        <Empty description="No additional guardians" />
      )}
    </Card>
  );
};

export default AdditionalGuardiansTab;
